
import Vue from 'vue';
import EnterpriseUpsellWrapper from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellWrapper.vue';

export default Vue.extend({
	name: 'MetricAnalyticsCard',
	props: {
		showEnterpriseUpsellUi: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
		borderColor: { type: String, default: 'var(--grey-700)' },
	},
	components: {
		EnterpriseUpsellWrapper,
	},
});
